import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ReferenceCard from '../components/ReferenceCard';
import { flaticonNormalIcons, flaticonAnimatedAnimalIcons, flaticonAnimatedFruitIcons } from '../data/referenceData';



export default function Reference() {
  return (
  <div className='page-content-reference'>
      <div className='reference-intro1'>
          <div className='d-flex flex-column justify-content-center align-items-center pt-3 px-3'>
              <h2>Reference</h2>
          </div>
      </div>

      <div className='reference-intro2'>
          <div className='d-flex flex-column justify-content-center align-items-center pt-3 px-3'>
              <div className='pb-2'><h3>Flaticon Icons</h3></div>
              
              <Container className='d-flex flex-column justify-content-center align-items-center'>
                <Row className='justify-content-center'>{flaticonNormalIcons.map((card) => ( <Col key={card.id} xs={12} md={4} className="mb-4 d-flex justify-content-center"><ReferenceCard key={card.id} cardTitle={card.label} cardImage={card.image} cardText={card.description} cardLink={card.url}/></Col>))}</Row>
                
                <div className='pb-2'><h3>Flaticon Animated Icons</h3></div>
                <Row className='justify-content-center'>{flaticonAnimatedAnimalIcons.map((card) => ( <Col key={card.id} xs={12} md={4} lg={2} className="mb-4 d-flex justify-content-center"><ReferenceCard key={card.id} cardTitle={card.label} cardImage={card.image} cardText={card.description} cardLink={card.url}/></Col>))}</Row>
                <Row className='justify-content-center pb-5'>{flaticonAnimatedFruitIcons.map((card) => ( <Col key={card.id} xs={12} md={4} lg={2} className="mb-4 d-flex justify-content-center"><ReferenceCard key={card.id} cardTitle={card.label} cardImage={card.image} cardText={card.description} cardLink={card.url}/></Col>))}</Row>
                
              </Container>
          </div>
      </div>
  </div>
  )
}
